export default "__VITE_ASSET__DqyngFID__"